import axiosClient from "utils/axios";
import { ApiList, ApiOptionList, ApiResponse } from "types/api.types";
import type { Designation } from "../types/designation.types";

export const getDesignations = async ({
  page = 1,
  limit = 20,
  search,
}: {
  page?: number;
  limit?: number;
  search?: string;
} = {}) => {
  const response = await axiosClient.get<ApiResponse<ApiList<Designation[]>>>(
    "/designations",
    { params: { page, limit, search: search?.trim() || undefined } },
  );
  return response.data;
};

export const getDesignationOptions = async ({
  query,
  page = 1,
  limit = 50,
}: {
  query?: string;
  page?: number;
  limit?: number;
}) => {
  const response = await axiosClient.get<ApiResponse<ApiOptionList>>(
    "/designations/options",
    { params: { query: query?.trim() || undefined, page, limit } },
  );
  return response.data;
};

export const createDesignation = async (payload: { name: string }) => {
  const response = await axiosClient.post<ApiResponse<Designation>>(
    "/designations",
    payload,
  );
  return response.data;
};

export const updateDesignation = async (
  id: number,
  payload: { name: string },
) => {
  const response = await axiosClient.put<ApiResponse<Designation>>(
    `/designations/${id}`,
    payload,
  );
  return response.data;
};

export const deleteDesignation = async (id: number) => {
  const response = await axiosClient.delete<ApiResponse<unknown>>(
    `/designations/${id}`,
  );
  return response.data;
};
